import {
  Component,
  ElementRef,
  HostListener,
  OnChanges,
  OnInit,
  Renderer2,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import {SectionService} from '../../../services/section-service';
import {MainSectionComponent} from './sections/main-section/main-section.component';
import {PlaceSectionComponent} from './sections/place-section/place-section.component';
import {CoachSectionComponent} from './sections/coach-section/coach-section.component';
import {ScheduleSectionComponent} from './sections/schedule-section/schedule-section.component';
import {ImagesSliderSectionComponent} from './sections/images-slider-section/images-slider-section.component';
import {RegistrationSectionComponent} from './sections/registration-section/registration-section.component';
import {ImagesScrollComponent} from '../../elements/images-scroll/images-scroll.component';
import {GoalSectionComponent} from './sections/goal-section/goal-section.component';
import {ServicesSectionComponent} from './sections/services-section/services-section.component';

@Component({
  selector: 'app-main',
  standalone: true,
  imports: [
    MainSectionComponent,
    PlaceSectionComponent,
    CoachSectionComponent,
    ScheduleSectionComponent,
    GoalSectionComponent,
    ImagesSliderSectionComponent,
    RegistrationSectionComponent,
    ImagesScrollComponent,
    ServicesSectionComponent
  ],
  templateUrl: './main.component.html',
  styleUrl: './main.component.scss'
})
export class MainComponent implements OnInit {
  constructor(private el: ElementRef,
              private render: Renderer2,
              public sectionService: SectionService) {
  }

  activeEl: number = 0;
  marginSection: number = 100;

  ngOnInit() {
    // window.scrollBy(0, 200);
  }


  getActive(id: string) {
    let isVisible = false;
    const el = document.getElementById(id);
    const scheduleDistance = el?.getBoundingClientRect();
    if (scheduleDistance) {
      isVisible = -scheduleDistance.top + this.marginSection > 0 &&
        -scheduleDistance.top + this.marginSection < scheduleDistance.height;
      if (isVisible) {
        return id;
      }
      return undefined;
    }
    return undefined;
  }

  scrollToSection(sectionId: string) {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({behavior: 'smooth', block: 'start'});
    }
  }

  @HostListener('window:scroll', ['$event'])
  scrolling() {
    const activeEl =
      this.getActive('main') ??
      this.getActive('organizers') ??
      this.getActive('place') ??
      this.getActive('coach') ??
      this.getActive('goal') ??
      this.getActive('schedule') ??
      this.getActive('services') ??
      this.getActive('images') ??
      this.getActive('registration');
      this.sectionService.setActiveSection(activeEl ?? 'main');
  }
}
